import React, { useMemo } from 'react'
import { TableRow, TableCell, Typography } from '@mui/material'
import { useMarkingContext } from '../MarkingContext/MarkingContext'
import MarkingMenu from '../MarkingMenu/MarkingMenu'
import RatingMenu from '../RatingMenu/RatingMenu'
import EffortAndConductMenu from '../EffortAndConductMenu/EffortAndConductMenu'

const CellMarking = ({
  marking = {},
  effortAndConduct = {},
  studentId,
  permission,
  currentPeriodicalReport,
  previousMarking,
  effortAndConductOptions = [],
  showRating,
  showEffortAndConduct
}) => {
  return (
    <>
      {currentPeriodicalReport.previousPeriodicalReportId && (
        <>
          <TableCell
            className='text-center h-8'
            style={{
              outline: '1px solid var(--muted)',
              background: 'rgba(0, 0, 0, 0.05)'
            }}
          >
            {previousMarking?.code || previousMarking?.assessmentAreaId}
          </TableCell>
          <TableCell
            className='text-start h-8'
            style={{
              outline: '1px solid var(--muted)',
              background: 'rgba(0, 0, 0, 0.05)'
            }}
          >
            {previousMarking?.name || previousMarking?.assessmentAreaId}
          </TableCell>
          <TableCell
            className='text-center'
            style={{
              outline: '1px solid var(--muted)',
              background: 'rgba(0, 0, 0, 0.05)'
            }}
          >
            {previousMarking?.level}
          </TableCell>
        </>
      )}
      {marking?.index === 0 && (
        <>
          <TableCell
            className='text-center h-8'
            rowSpan={marking?.previousLevels?.length}
            style={{
              outline: '1px solid var(--muted)'
            }}
          >
            {marking?.assessmentAreaCode || marking?.assessmentAreaId}
          </TableCell>
          <TableCell
            className='text-start h-8'
            rowSpan={marking?.previousLevels?.length}
            style={{
              outline: '1px solid var(--muted)'
            }}
          >
            {marking?.assessmentAreaName || marking?.assessmentAreaId}
          </TableCell>
          <TableCell
            className='text-center'
            rowSpan={marking?.previousLevels?.length}
            style={{
              outline: '1px solid var(--muted)'
            }}
          >
            {permission && currentPeriodicalReport?.isCurrent ? (
              <MarkingMenu marking={marking} studentId={studentId} />
            ) : (
              marking?.level
            )}
          </TableCell>
          {showRating && (
            <TableCell
              className='text-center'
              rowSpan={marking?.previousLevels?.length}
              style={{
                outline: '1px solid var(--muted)'
              }}
            >
              {permission && currentPeriodicalReport?.isCurrent ? (
                <RatingMenu rating={marking?.rating?._id} marking={marking} studentId={studentId} />
              ) : (
                marking?.rating?.name || '-'
              )}
            </TableCell>
          )}
          {showEffortAndConduct &&
            effortAndConductOptions?.map((option) => {
              const optionId = marking?.effortAndConduct?.[option?._id]
              const find = option?.ratings?.find((x) => x._id === optionId)

              return (
                <TableCell
                  key={`period-effort-conduct-${option?.code}`}
                  className='text-center'
                  rowSpan={marking?.previousLevels?.length}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  {permission && currentPeriodicalReport?.isCurrent ? (
                    <EffortAndConductMenu
                      effortAndConductId={option?._id}
                      optionId={optionId}
                      options={option?.ratings || []}
                      marking={marking}
                      studentId={studentId}
                    />
                  ) : (
                    find?.name || optionId
                  )}
                </TableCell>
              )
            })}
        </>
      )}
    </>
  )
}

const TableRowStudent = ({
  row,
  rowMarking,
  handleMenuOpen,
  effortAndConductOptions,
  showRating = true,
  showEffortAndConduct = true
}) => {
  const { currentPeriodicalReport, permission } = useMarkingContext()

  const rowsMarking = useMemo(() => {
    let rows = []
    rowMarking.forEach((marking) => {
      if (Array.isArray(marking.previousLevels)) {
        rows = rows.concat(
          marking.previousLevels.map((previousMarking, index) => ({
            ...marking,
            previousMarking,
            index
          }))
        )
      } else {
        rows.push({
          ...marking,
          previousMarking: null
        })
      }
    })
    return rows
  }, [rowMarking])

  const rowSpan = rowsMarking.length > 0 ? rowsMarking.length : 1

  return (
    <>
      <TableRow>
        <TableCell
          className={['sticky left-0px max-w-200px min-w-200px z-1 bg-white'].join(', ')}
          rowSpan={rowSpan}
          style={{
            outline: '1px solid var(--muted)'
          }}
        >
          <Typography>
            {row?.studentCode} - {row?.studentName}
          </Typography>
          <Typography className='text-sm text-primary'>{row?.yearLevel?.name}</Typography>
        </TableCell>
        <CellMarking
          marking={rowsMarking?.[0]}
          studentId={row.studentId}
          effortAndConductOptions={effortAndConductOptions}
          effortAndConduct={row?.effortAndConduct || {}}
          permission={permission}
          handleMenuOpen={handleMenuOpen}
          currentPeriodicalReport={currentPeriodicalReport}
          previousMarking={rowsMarking?.[0]?.previousMarking}
          showRating={showRating}
          showEffortAndConduct={showEffortAndConduct}
        />
      </TableRow>
      {rowsMarking.length > 1 &&
        rowsMarking.slice(1).map((marking, index) => (
          <TableRow key={`student-${row?.studentId}-assessment-area-${marking?.assessmentAreaId}-${index}`}>
            <CellMarking
              marking={marking}
              studentId={row.studentId}
              effortAndConductOptions={effortAndConductOptions}
              effortAndConduct={row?.effortAndConduct || {}}
              permission={permission}
              handleMenuOpen={handleMenuOpen}
              currentPeriodicalReport={currentPeriodicalReport}
              previousMarking={marking.previousMarking}
              showRating={showRating}
              showEffortAndConduct={showEffortAndConduct}
            />
          </TableRow>
        ))}
    </>
  )
}

export default TableRowStudent
